import { SmartLink, ColorButton } from "@/components/ui";


export function ManageComments() {
    return (
        <div className="pt-8">
            <div className="flex flex-wrap gap-4 md:justify-between justify-center">
                <div className="flex flex-wrap gap-4 justify-center items-center">

                    <SmartLink type={"internal"} route={"adminCommentsFeedback"}>
                        <ColorButton>
                            Retornos
                        </ColorButton>
                    </SmartLink>

                    <SmartLink type={"internal"} route={"adminCommentsQuestions"}>
                        <ColorButton>
                            Perguntas
                        </ColorButton>
                    </SmartLink>
                </div>

                <SmartLink type="external" route="blogSend">
                    <ColorButton>Adicionar Novo</ColorButton>
                </SmartLink>
            </div>
        </div>
    )
}